// Brand constants — single source of truth
export const PHONE_DISPLAY = "61 98266-2434";
export const PHONE_RAW = "5561982662434";
export const WHATSAPP_MESSAGE = "Olá, Luara! Vim pelo seu site e gostaria de agendar uma sessão.";
export const WHATSAPP_URL = `https://wa.me/${PHONE_RAW}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

/**
 * Click handler for every WhatsApp CTA on the page.
 * - Fires the Google Ads conversion event (gtag_report_conversion declared in index.html)
 * - Lets the conversion ping land before redirecting via window.location (handled inside gtag callback)
 * - Falls back to a direct same-tab navigation if gtag failed to load (adblock, offline)
 */
export const handleWhatsAppClick = (e) => {
    if (e && typeof e.preventDefault === "function") e.preventDefault();
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
        window.gtag_report_conversion(WHATSAPP_URL);
    } else if (typeof window !== "undefined") {
        window.location.href = WHATSAPP_URL;
    }
    return false;
};

export const INSTAGRAM_HANDLE = "@psicologa.luaraaina";
export const INSTAGRAM_URL = "https://instagram.com/psicologa.luaraaina";

export const ADDRESS = "Ed. Advance 2, 915 Sul, sala 20, 1º subsolo — Brasília/DF";

export const PSYCHOLOGIST = {
    name: "Luara Ainá do Nascimento",
    crp: "CRP 01/17472",
    years: 14,
};

export const IMAGES = {
    hero: "https://customer-assets.emergentagent.com/job_fe33f82c-d23a-409b-8e3f-36e607800bc5/artifacts/va8ibc62_escolhida1.jpeg",
    about: "https://customer-assets.emergentagent.com/job_fe33f82c-d23a-409b-8e3f-36e607800bc5/artifacts/seh4auo9_escolhida2.jpeg",
    process: "https://customer-assets.emergentagent.com/job_fe33f82c-d23a-409b-8e3f-36e607800bc5/artifacts/w5hvd55j_escolhida3.jpeg",
};

export const VIDEO_URL = "https://customer-assets.emergentagent.com/job_fe33f82c-d23a-409b-8e3f-36e607800bc5/artifacts/vmhbgvxz_video-pagina.mp4";
